import { DictionaryEntry } from '@sdbn/common';
import { MasterDetailListEntry } from "@sdbn/common";

export class TransportMessage implements MasterDetailListEntry {
  id: number;
  name: string;

  constructor(message?: TransportMessage) {
    if (message != null) {
      this.id = message.id;
      this.name = message.name;
    }
  }

  public get listTitle(): string {
    return this.name;
  }

  public get listTitleDictionaryKey(): string {
    return null;
  }

  public get listSubTitle(): string {
    return null;
  }

  public get groupIdentifier(): String {
    return null;
  }

  public get childs() : Array<MasterDetailListEntry> {
    return null;
  }

}


export class TransportMessageDetails {
  id: number;
  name: string;
  messageLong = new DictionaryEntry();
  messageShort = new DictionaryEntry();

  constructor(message?: TransportMessageDetails) {
    if (message != null) {
      this.id = message.id;
      this.name = message.name;

      if (message.messageLong != null) {
        this.messageLong = new DictionaryEntry(message.messageLong);
      }

      if (message.messageShort != null) {
        this.messageShort = new DictionaryEntry(message.messageShort);
      }
    }
  }
}


